import { Badge } from '@/components/ui/badge';
import { useUserRoles } from '@/hooks/useUserRoles';
import { useOrganizationContext } from '@/context/organization-provider';

interface AdminPageHeaderProps {
  title: string;
  description: string;
  showOrganizationInfo?: boolean;
}

export const AdminPageHeader = ({ 
  title, 
  description, 
  showOrganizationInfo = false 
}: AdminPageHeaderProps) => {
  const { roles } = useUserRoles();
  
  // Safely try to get organization context, handle when provider is not available
  let organization = null;
  if (showOrganizationInfo) {
    try {
      const context = useOrganizationContext();
      organization = context.organization;
    } catch (error) {
      // OrganizationProvider not available, which is fine for System Admin panel
      console.warn('[AdminPageHeader] OrganizationProvider not available');
    }
  }

  return (
    <div className="flex flex-col space-y-4 lg:flex-row lg:items-center lg:justify-between lg:space-y-0">
      <div className="space-y-1">
        <h1 className="text-2xl font-bold text-foreground sm:text-3xl">
          {title}
        </h1>
        <p className="text-sm text-muted-foreground sm:text-base">
          {description}
        </p>
      </div>
      
      <div className="flex flex-col space-y-2 sm:flex-row sm:items-center sm:space-x-2 sm:space-y-0">
        <Badge variant={roles.isPlatformAdmin ? 'default' : 'secondary'} className="w-fit">
          {roles.platformRole}
        </Badge>
        
        {showOrganizationInfo && organization && (
          <Badge variant="outline" className="w-fit">
            {roles.organizationRole} in {organization.name}
          </Badge>
        )}
      </div>
    </div>
  );
};